import { UserData } from "./../../environments/global";
import { OnInit, Component } from "@angular/core";
import { DatePipe } from "@angular/common";

import { HttpErrorResponse } from "@angular/common/http";
import { NzMessageService, NzNotificationService, id_ID } from "ng-zorro-antd";
import { HomeComponent } from "../home.component";

import {
  GlobalComponent,
  Ordine,
  Result,
  Aziende,
} from "../../environments/global";
import { stringify } from "querystring";

@Component({
  selector: "app-premi-report",
  templateUrl: "premi-report.html",
  styleUrls: ["premi-report.scss"],
  providers: [DatePipe],
})
export class PremiReportComponent implements OnInit {
  // TABLE VARS
  formatterEuro = (value: number) => `€ ${value}`;
  parserEuro = (value: string) => value.replace("€ ", "");

  rangeDate: Date[] = [];
  rangePlace: string[] = ["Da data", "A Data"];
  dateFormat = "dd/MM/yyyy";

  dataSet = [];
  public displayData = [...this.dataSet];
  editCache = {};

  // COMPONENT VARS
  isLoading: boolean = false;
  userData: Array<UserData>;

  destinatario = "all";
  destinatari = [];

  totPrize: Number = 0;

  constructor(
    public g: GlobalComponent,
    private datepipe: DatePipe,
    public home: HomeComponent,
    private notification: NzNotificationService,
    private message: NzMessageService
  ) {
    this.setup();
  }
  // ################################################
  // CLASS: ON INIT
  ngOnInit() {
    this.setup();
  }

  setup() {
    // SETUP INTERFACE
    this.g.menuState = 10;
    this.g.homeTitle = "Report Premi";
  }
  loadData() {
    this.isLoading = true;
    let query: string =
      "SELECT * from chk_orders WHERE `status`= 0" +
      " AND `prize`= 1" +
      " AND  `date`>= '" +
      this.datepipe.transform(this.rangeDate[0], "yyyy-MM-dd") +
      "' AND `date`<= '" +
      this.datepipe.transform(this.rangeDate[1], "yyyy-MM-dd") +
      "' ORDER BY `id` DESC";

    this.g.mysql(query).subscribe(
      (res: Result) => {
        this.isLoading = false;

        this.dataSet = res.data;

        this.dataSet.forEach((e: Ordine) => {
          if (e.prize) {
            this.calcH(e.id);
            e["prizeTotal"] = this.calcPrize(e);
            this.totPrize += e["prizeTotal"];
          }
        });

        this.updateEditCache();
        // console.log(this.dataSet);
      },
      (error: HttpErrorResponse) => {
        this.isLoading = false;
        this.notification.error(
          "Si è vericato un errore non previsto",
          error.statusText,
          { nzDuration: 0 }
        );
      }
    );

    query = "SELECT name, surname, email FROM chk_users WHERE `email` > ''";
    this.g.mysql(query).subscribe((res: Result) => {
      this.destinatari = res.data;
    });
  }

  updateEditCache(): void {
    if (this.dataSet != null) {
      this.dataSet.forEach((item) => {
        if (!this.editCache[item.id]) {
          this.editCache[item.id] = {
            edit: false,
            data: item,
          };
        }
      });
    }
    this.displayData = [...this.dataSet];
  }

  calcH(orderId: string) {
    const query: string =
      "SELECT SUM(chk_times.h) AS h FROM chk_times" +
      " WHERE `orderId`=" +
      orderId;
    this.g.mysql(query).subscribe((res: Result) => {
      const index = this.dataSet.findIndex((item) => item.id === orderId);
      this.dataSet[index].total = res.data[0].h ? res.data[0].h : 0;
    });
  }

  isNull(val) {
    return typeof val === "number";
  }

  calcPrize(o: Ordine) {
    var deltaH;
    if (o.forecast != 0) deltaH = o.forecast - o.total;
    else deltaH = o.total;
    // if (deltaH <= 0) return 0;
    const costH = deltaH * o.costH;
    const costM = o.costM - o.costMReal;

    // console.log(
    //   "id",
    //   o.id,
    //   "o.forecast",
    //   o.forecast,
    //   "o.total",
    //   o.total,
    //   "deltaH",
    //   deltaH
    // );

    const prizeValue = Math.round((costH + costM) / 2);
    return prizeValue;
  }

  sendMail() {
    let destinatari: string = "";

    if (this.destinatario == "all") {
      this.destinatari.forEach((d: string) => {
        destinatari += d["email"] + ",";
      });
    } else {
      destinatari = this.destinatario;
    }
    this.isLoading = true;

    const da = this.datepipe.transform(this.rangeDate[0], "dd-MM-yyyy");
    const a = this.datepipe.transform(this.rangeDate[1], "dd-MM-yyyy");

    this.g.sendPremi(destinatari, this.dataSet, da, a, this.totPrize).subscribe(
      (res: Result) => {
        this.isLoading = false;
        this.notification.success(
          "Email inviata",
          "Operazione completata con successo",
          { nzDuration: this.g.fastTime }
        );
      },
      (error: HttpErrorResponse) => {
        this.isLoading = false;
        this.notification.error(
          "Si è vericato un errore non previsto",
          error.statusText,
          { nzDuration: 0 }
        );
      }
    );
  }
}
